import React from 'react';
import SearchBarButton from './SearchBarButton';
import GoBackButton from './GoBackButton';
import GoNextButton from './GoNextButton';
import HomeButton from './HomeButton';
import SearchContainer from './SearchContainer';

function SearchBar() {
  return (
    <div className="searchbar">
      <GoBackButton />
      <GoNextButton />
      <SearchBarButton>
        <i className="icofont-refresh"
           style={{ fontSize: '13px', lineHeight: '27px' }}></i>
      </SearchBarButton>
      <HomeButton />
      <span className="button-delimeter"></span>
      <SearchContainer />
      <span className="button-delimeter"></span>
      <SearchBarButton className="user-icon">
      </SearchBarButton>
      <SearchBarButton>
        <i className="icofont-navigation-menu"></i>
      </SearchBarButton>
      <div className="chrome-tabs-bottom-bar"></div>
    </div>
  );
};

export default SearchBar;
